import Button from '@base/Button/Button';
import styled from '@emotion/styled';

import { Fonts, Spacings } from '@styles/index';
import { getJoinBatchLabel } from '../utils';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;
const SlashMessagePrice = styled.div`
  display: flex;
  flex-direction: column;
`;
const PriceText = styled.div`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.ULTRA_SMALL};
  color: var(--color-text-primary);
`;
const Price = styled.div`
  font-size: ${Fonts.H4};
  color: var(--color-text-primary);
  font-weight: ${Fonts.HEAVY};
`;
const SlashPriceText = styled(Price)`
  text-decoration-line: line-through;
  margin-right: ${Spacings.SPACING_2B};
  color: var(--color-text-secondary);
  font-weight: ${Fonts.REGULAR};
`;

const JoinBatchButton = styled(Button)`
  background-color: var(--color-base-fill);
  color: var(--color-text-tertiary);
  height: ${Spacings.SPACING_12B};
  width: 111px;
  &:active {
    background-color: var(--color-i-black);
  }
`;

const SlashPriceWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;
const SlashPriceMessage = styled.div`
  font-weight: ${Fonts.LIGHT};
  font-size: ${Fonts.ULTRA_SMALL};
  color: var(--color-text-primary);
  padding-bottom: ${Spacings.SPACING_1B};
`;
const BatchPriceCard = ({
  slashPriceMessage,
  onJoinBatch,
  batchDetails,
  classType
}) => {
  const price = batchDetails?.price;
  const listPrice = batchDetails?.listPrice;
  const isDiscountAvailable = batchDetails?.isDiscountAvailable;
  const joinBatchLabel = getJoinBatchLabel(classType);

  return (
    <Wrapper>
      <SlashMessagePrice>
        {slashPriceMessage ? (
          <SlashPriceMessage>{slashPriceMessage}</SlashPriceMessage>
        ) : (
          <PriceText>Price</PriceText>
        )}

        <SlashPriceWrapper>
          {isDiscountAvailable && listPrice && (
            <SlashPriceText>{`₹${listPrice}`}</SlashPriceText>
          )}
          <Price>{`₹${price}`} </Price>
        </SlashPriceWrapper>
      </SlashMessagePrice>
      <JoinBatchButton
        onClick={onJoinBatch}
        variant="filled"
        label={joinBatchLabel}
      />
    </Wrapper>
  );
};

export default BatchPriceCard;
